/* eslint-disable react/prop-types */
import { Modal, Divider } from "antd";
import FormButton from "../Buttons/FormButton";
import FormCancelButton from "../Buttons/FormCancelButton";

function DeleteModal({
  open,
  handleOk,
  handleCancel,
  confirmLoading,
  modalText,
  extra,
  okText = "Delete",
}) {
  const [prefix, highlight] = modalText?.split("%") || [];

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      closeIcon={false}
      centered
      // destroyOnClose
      maskClosable={!confirmLoading}
    >
      <div className="px-6 pt-4 pb-1">
        <h2 className="text-lg font-semibold text-gray-800 mb-5">
          Are you sure?
        </h2>
        {/* <Divider className="!my-2" /> */}
        <p className="text-sm text-gray-600 leading-6">
          {prefix}{" "}
          <span className="font-semibold text-red-700">{highlight}</span>
        </p>
        {extra && <div className="mt-3">{extra}</div>}
      </div>

      <Divider className="!my-3" />
      <div className="px-6 pb-4 flex justify-end gap-3">
        <FormCancelButton
          text="Cancel"
          onClick={handleCancel}
          disabled={confirmLoading}
        />
        <FormButton
          text={okText}
          type="primary"
          isDanger={true}
          loading={confirmLoading}
          onClick={handleOk}
        />
      </div>
    </Modal>
  );
}

export default DeleteModal;
